import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ClientActivityLogComponent } from '@app/modules/log/pages/client-activity-log/client-activity-log.component';
import { CaseActivityLogComponent } from '@app/modules/log/pages/case-activity-log/case-activity-log.component';
import { LogTableComponent } from '@app/modules/log/components/log-table/log-table.component';
import {BillingLogComponent} from '@app/modules/log/pages/billing-log/billing-log.component';
import {BillingLogTableComponent} from '@app/modules/log/components/billing-log-table/billing-log-table.component';


@NgModule({
    declarations: [
        CaseActivityLogComponent,
        ClientActivityLogComponent,
        LogTableComponent,
        BillingLogComponent,
        BillingLogTableComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
    ]
})
export class LogModule { }
